module.exports = __webpack_public_path__ + "img/ally.a7e61953.png";